import * as XLSX from 'xlsx'
import showToast from '../components/CustomToast/toastHelper';
export const exportToXLSX= (data: any, filename:string)=> {
    if (!data || !data.length) {
        console.error('No data provided');
        showToast('No data provided', "error")
        return;
    }
    // Convert data array to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate a binary string representing the workbook
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

    // Create a buffer array to convert the binary string to an ArrayBuffer
    function s2ab(s: any) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }

    // Create a blob with the workbook content
    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

    // Create a link element and trigger the download
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}